import { render, staticRenderFns } from "./FulfillOrders.vue?vue&type=template&id=8861c656&scoped=true"
import script from "./FulfillOrders.vue?vue&type=script&lang=js"
export * from "./FulfillOrders.vue?vue&type=script&lang=js"
import style0 from "./FulfillOrders.vue?vue&type=style&index=0&id=8861c656&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8861c656",
  null
  
)

export default component.exports